import * as React from "react";
import { Dropdown } from "azure-devops-ui/Dropdown";
import { DropdownSelection } from "azure-devops-ui/Utilities/DropdownSelection";
import { dropdownItems } from "./Data";

export default class DropdownDefaultSelectionExample extends React.Component {
    private selection = new DropdownSelection();

    public constructor(props: {}) {
        super(props);
        // Select the first item by default.
        this.selection.select(1);
    }

    public render() {
        return (
            <div style={{ margin: "8px" }}>
                <Dropdown
                    ariaLabel="Default selection"
                    className="example-dropdown"
                    placeholder="Select an Option"
                    items={dropdownItems}
                    selection={this.selection}
                />
            </div>
        );
    }
}
